import React from 'react';
import { Box, Typography, IconButton } from "@mui/material";
import { Close } from '@material-ui/icons';
import { DQC_COLORS } from '../../../../../../utils/constants';

const DQCompetencyDialog = ({ popupContent, onClose }) => {
    if (!popupContent) return null;

    return (
        <>
            <Box
                onClick={onClose}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 1299,
                }}
            />
            <Box
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '80%',
                    maxWidth: '500px',
                    backgroundColor: 'var(--brand-surface, #fff)',
                    border: '1px solid var(--brand-border, #000)',
                    borderRadius: '20px',
                    boxShadow: '0 24px 48px rgba(0,0,0,0.2)',
                    padding: 16,
                    zIndex: 1300,
                }}
            >
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: 'var(--brand-text, #000)',
                    }}
                >
                    <Close />
                </IconButton>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, padding: '15px 20px' }}>
                    <Box sx={{
                        backgroundColor: DQC_COLORS[popupContent.dqc_no] || '#D2DD2C',
                        color: 'white',
                        borderRadius: '20px',
                        px: 2,
                        py: 1,
                        fontWeight: 'medium',
                        mb: 2
                    }}>
                        {popupContent.code}
                    </Box>
                    <Typography
                        variant="h5"
                        component="h2"
                        style={{
                            fontWeight: 'bold',
                            textAlign: 'center',
                            color: DQC_COLORS[popupContent.dqc_no] || '#D2DD2C'
                        }}
                    >
                        {popupContent.title}
                    </Typography>
                    <Typography
                        style={{
                            marginTop: 16,
                            whiteSpace: 'pre-line',
                            textAlign: 'left',
                            fontSize: '11px',
                            color: 'var(--brand-text, #000)'
                        }}
                    >
                        {popupContent.description}
                    </Typography>
                </Box>
            </Box>
        </>
    );
};

export default DQCompetencyDialog;
